import { Pipe, PipeTransform } from '@angular/core';
import { isObservable, Observable, of } from 'rxjs';
import { catchError, map, startWith } from 'rxjs/operators';

@Pipe({
  name: 'withStatus',
})
export class WithStatusPipe implements PipeTransform {
  transform(val: Observable<any>): any {
    return isObservable(val)
      ? val.pipe(
          map((value: any) => ({ loading: false, value })),
          startWith({ loading: true }),
          catchError((error: any) => of({ loading: false, error })),
        )
      : val;
  }
}
